export default "__VITE_ASSET__BduEKtVO__"